import type { DemoUser } from '../domain/models'
import type { ClockPort } from '../ports'

export function createDemoUsers(clock: ClockPort): DemoUser[] {
  const timestamp = clock.now()
  return [
    {
      id: 'user_demo_1',
      createdAt: timestamp,
      updatedAt: timestamp,
      name: 'Jess Technician',
      email: 'jess.technician@example.com',
      avatarUrl:
        'https://images.pexels.com/photos/1181519/pexels-photo-1181519.jpeg?auto=compress&cs=tinysrgb&w=80&h=80&dpr=2',
      password: 'password123',
      isAdmin: true,
    },
  ]
}
